<template>
    <div></div>
</template>

<script>
export default {
    name:'HomeownerHomeSelections',
}
</script>